/* eslint-disable react-hooks/exhaustive-deps */
import { ThemeProvider } from "@emotion/react";
import { Send } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { FaFileWord } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link as domLink, useParams } from "react-router-dom";
import OwnedStockConfirmation from "../../components/Comfirmation/OwnedStockConfirmation";
import ReceivablePayableConfirmation from "../../components/Comfirmation/ReceivablePayableConfirmation";
import DefaultPaper from "../../components/DefaultPaper";
import ConfirmationLetterForm from "../../components/Form/ConfirmationLetterForm";
import MailForm from "../../components/Form/MailForm";
import FormDialog from "../../components/FormDialog";
import TextFieldWithTooltip from "../../components/Input/TextFieldWithTooltip";
import ConfirmerSpreadsheet from "../../components/SpreadSheets/ConfirmerSpreadsheet";
import useApi, { httpClient, useDownloadFile } from "../../hooks/useApi";
import { infoTheme } from "../../style/theme";
import { confirmerDataMapper } from "../../utils/ConfirmerListHead";
import Constants from "../../utils/Constants";

const ConfirmationLetter = ({ title }) => {
  const params = useParams();
  const { connect } = useApi();
  const { downloadFile } = useDownloadFile();
  const role = useSelector((state) => state.role.role);
  const [disableEdit, setDisableEdit] = useState(true);

  // 確認状情報取得
  const [fetchResult, setFetchResult] = useState();
  const [accountTitles, setAccountTitles] = useState([]);
  const fetchData = async () => {
    const result = await connect(() => {
      return httpClient.get(`/api/${role}/GetConfirmation?id=${params.id}`);
    });
    setFetchResult(result?.data);
    // 債権債務の場合は勘定科目一覧を取得する
    if (
      result?.data?.data?.confirmationType ===
      Constants.CONFIRMATION_LETTER_TYPE.RECEIVABLE_PAYABLE
    ) {
      const accountTitleFetchResult = await httpClient.get(
        `/api/auditor/GetAccountTitles?companyId=${result?.data?.data?.companyId}`
      );
      setAccountTitles(accountTitleFetchResult?.data?.data);
    }
  };
  useEffect(() => {
    fetchData();
  }, [role]);

  // 表示制御
  const initializeState = () => {
    const confirmationLetterStatus =
      fetchResult?.data?.confirmationLetterStatus;
    const procedureStatus = fetchResult?.data?.procedureStatus;
    const hasEditAuthority =
      fetchResult?.data?.clientAuthority ===
        Constants.CLIENT_AUTHORITY_TYPE.EDIT ||
      fetchResult?.data?.clientAuthority ===
        Constants.CLIENT_AUTHORITY_TYPE.EDIT_APPROVAL;
    // 「ステータス」の表示制御
    setStatusDropdown(
      role === Constants.ROLE.AUDITOR &&
        confirmationLetterStatus !==
          Constants.CONFIRMATION_LETTER_STATUS.REGISTERED
    );
    // 「確認結果」の表示制御
    setConfirmationResultDropdown(
      role === Constants.ROLE.AUDITOR &&
        confirmationLetterStatus ===
          Constants.CONFIRMATION_LETTER_STATUS.RESPONSED
    );
    // 「確認依頼メール送付」ボタンの表示制御
    setSendConfirmationButton(
      role === Constants.ROLE.AUDITOR &&
        fetchResult?.data?.sendingMethod ===
          Constants.SENDING_METHOD.EMAIL_OR_POST &&
        (confirmationLetterStatus ===
          Constants.CONFIRMATION_LETTER_STATUS.WAITING_FOR_SHIPMENT ||
          confirmationLetterStatus ===
            Constants.CONFIRMATION_LETTER_STATUS.SHIPPED)
    );
    // 「確認状ファイル出力」ボタンの表示制御
    setDlConfirmationButton(role === Constants.ROLE.AUDITOR);
    // 編集可否制御
    setDisableEdit(
      confirmationLetterStatus !==
        Constants.CONFIRMATION_LETTER_STATUS.REGISTERED ||
        procedureStatus !== Constants.PROCECURE_STATUS.REGISTERED ||
        (role === Constants.ROLE.CLIENT && !hasEditAuthority)
    );
  };
  useEffect(() => initializeState(), [role, fetchResult]);
  // 「ステータス」関連
  const [statusDropdown, setStatusDropdown] = useState(false);
  const [confirmationLetterStatus, setConfirmationLetterStatus] = useState("");
  const [statusChangeDialogOpen, setStatusChangeDialogOpen] = useState(false);
  useEffect(() => {
    setConfirmationLetterStatus(fetchResult?.data?.confirmationLetterStatus);
  }, [fetchResult]);
  const onChangeConfirmationLetterStatus = (e, forceChange) => {
    const changeStatus = async (status) => {
      await connect(() => {
        return httpClient.post(
          "../../api/auditor/UpdateConfirmationSelective",
          {
            id: params.id,
            confirmationLetterStatus: status ?? e?.target?.value,
          }
        );
      }, "保存しました");
      fetchData();
    };
    if (forceChange) {
      setConfirmationLetterStatus(
        Constants.CONFIRMATION_LETTER_STATUS.REGISTERED
      );
      changeStatus(Constants.CONFIRMATION_LETTER_STATUS.REGISTERED);
      setStatusChangeDialogOpen(false);
    } else if (
      e.target.value === Constants.CONFIRMATION_LETTER_STATUS.REGISTERED
    ) {
      setStatusChangeDialogOpen(true);
    } else {
      setConfirmationLetterStatus(e.target.value);
      changeStatus();
    }
  };
  // 「確認結果」関連
  const [confirmationResultDropdown, setConfirmationResultDropdown] =
    useState(false);
  const [confirmationResult, setConfirmationResult] = useState("");
  useEffect(
    () => setConfirmationResult(fetchResult?.data?.confirmationResult),
    [fetchResult]
  );
  const onChangeConfirmationResult = async (e) => {
    await connect(() => {
      return httpClient.post("../../api/auditor/UpdateConfirmationSelective", {
        id: params.id,
        confirmationResult: e.target.value,
      });
    }, "保存しました");
    fetchData();
  };
  // 「確認状メール送付」関連
  const [sendConfirmationButton, setSendConfirmationButton] = useState(false);
  // 「確認状ファイルF出力」関連
  const [dlConfirmationButton, setDlConfirmationButton] = useState(false);

  //確認状編集関連
  const [confirmLetterEditDialogOpen, setConfirmationLetterEditDialogOpen] =
    useState(false);
  const handleCloseConfirmationLetterEdit = (value) => {
    setConfirmationLetterEditDialogOpen(false);
    fetchData();
  };
  // 確認依頼メール一括送付関連
  const [mailDialogOpen, setMailDialogOpen] = useState();
  const handleCloseMailDialog = () => {
    setMailDialogOpen(false);
    fetchData();
  };

  return (
    <>
      <Typography variant="h6">{title}</Typography>

      {/* メニュー */}
      <DefaultPaper title={"メニュー"}>
        <Box
          sx={{
            "& > button": { marginRight: "1rem" },
            "& > div": { marginRight: "1rem" },
          }}
        >
          <FormControl>
            <InputLabel>ステータス</InputLabel>
            <Select
              value={confirmationLetterStatus}
              disabled={!statusDropdown}
              onChange={(e) => onChangeConfirmationLetterStatus(e)}
            >
              {fetchResult?.confirmationLetterStatusList?.map((row) => (
                <MenuItem value={row.code} key={row.code}>
                  {row.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* 「ステータス」変更確認ダイアログ */}
          <Dialog
            maxWidth="xs"
            open={statusChangeDialogOpen}
            onClose={() => setStatusChangeDialogOpen(false)}
          >
            <DialogContent>
              ステータスを「登録」に変更すると、再度クライアントによる承認が必要となります。
              <br />
              よろしいですか？
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => onChangeConfirmationLetterStatus(e, true)}
              >
                変更
              </Button>
              <Button onClick={() => setStatusChangeDialogOpen(false)}>
                キャンセル
              </Button>
            </DialogActions>
          </Dialog>
          <FormControl>
            <InputLabel>確認結果</InputLabel>
            <Select
              value={confirmationResult}
              disabled={!confirmationResultDropdown}
              onChange={(e) => onChangeConfirmationResult(e)}
            >
              {fetchResult?.confirmationResultList?.map((row) => (
                <MenuItem value={row.code} key={row.code}>
                  {row.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {sendConfirmationButton && (
            <Button
              onClick={() => setMailDialogOpen(true)}
              startIcon={<Send />}
            >
              確認状メール送付
            </Button>
          )}
          {dlConfirmationButton &&
            fetchResult?.data?.confirmationType ===
              Constants.CONFIRMATION_LETTER_TYPE.OWNED_STOCK && (
              <Button
                startIcon={<FaFileWord />}
                onClick={() =>
                  downloadFile(
                    `/api/auditor/DownloadConfirmationLetterFiles?confirmationLetterId=${params.id}`
                  )
                }
              >
                郵送用確認状出力
              </Button>
            )}
        </Box>
      </DefaultPaper>

      {/* 概要 */}
      <DefaultPaper title="確認状概要">
        <Grid container>
          <ThemeProvider theme={infoTheme}>
            <Grid item xs={12}>
              <InputLabel>被監査企業</InputLabel>
              <Link
                color="inherit"
                noWrap
                to={`/${role}/company/${fetchResult?.data?.companyId}`}
                padding="16.5px 14px"
                component={domLink}
                sx={{
                  color: "#3f51b5",
                }}
              >
                {fetchResult?.data?.companyName}
              </Link>
            </Grid>
            <Grid item xs={3}>
              <TextFieldWithTooltip
                label="基準日"
                value={fetchResult?.data?.referenceDateFormatted}
              />
            </Grid>
            <Grid item xs={9}>
              <InputLabel>確認手続名称</InputLabel>
              <Link
                color="inherit"
                noWrap
                to={`/${role}/procedure/${fetchResult?.data?.procedureId}`}
                padding="16.5px 14px"
                component={domLink}
                sx={{
                  color: "#3f51b5",
                }}
              >
                {fetchResult?.data?.procedureName}
              </Link>
            </Grid>
            <Grid item xs={3}>
              <TextFieldWithTooltip
                label="リファー番号"
                value={fetchResult?.data?.referNo}
              />
              <TextFieldWithTooltip
                label="確認先名称"
                value={fetchResult?.data?.confirmationDestination}
              />
            </Grid>
            <Grid item xs={3}>
              <TextFieldWithTooltip
                label="確認状種別"
                value={fetchResult?.data?.confirmationTypeLabel}
              />
            </Grid>
            <Grid item xs={3}>
              <TextFieldWithTooltip
                label="回収希望日"
                value={fetchResult?.data?.desiredCollectionDateFormatted}
              />
              {/* <TextFieldWithTooltip
                label="回収状況"
                value={fetchResult?.data?.collectionStatusLabel}
              /> */}
            </Grid>
            <Grid item xs={3}>
              <TextFieldWithTooltip
                label="送付方法"
                value={fetchResult?.data?.sendingMethodLabel}
              />
              <Box textAlign="right">
                <Button
                  disabled={disableEdit}
                  onClick={() => setConfirmationLetterEditDialogOpen(true)}
                >
                  編集
                </Button>
              </Box>
            </Grid>
          </ThemeProvider>
          <Grid item xs={11} textAlign={"right"}></Grid>
        </Grid>
        {/* 確認状概要編集ダイアログ */}
        <FormDialog
          onClose={() => setConfirmationLetterEditDialogOpen(false)}
          open={confirmLetterEditDialogOpen}
          title={"確認状概要の編集"}
          maxWidth="sm"
        >
          <ConfirmationLetterForm
            targetData={fetchResult?.data}
            confirmationType={fetchResult?.data?.confirmationType}
            {...fetchResult}
            closeHandler={handleCloseConfirmationLetterEdit}
          />
        </FormDialog>
      </DefaultPaper>

      {/* 担当者一覧 */}
      <DefaultPaper title="確認先担当者一覧">
        <ConfirmerSpreadsheet
          targetData={confirmerDataMapper({ data: fetchResult?.confirmerList })}
          confirmationLetterId={params.id}
          confirmerAuthorityTypeList={fetchResult?.confirmerAuthorityTypeList}
          postDeterminedHandler={() => fetchData()}
          postSaveHandler={fetchData}
          disabled={disableEdit}
        />
      </DefaultPaper>

      {/* 確認内容 */}
      <DefaultPaper title={"確認内容"}>
        {/* 所有株式 */}
        {fetchResult?.data?.confirmationType ===
          Constants.CONFIRMATION_LETTER_TYPE.OWNED_STOCK && (
          <OwnedStockConfirmation
            targetData={fetchResult?.data}
            presenceOrAbsenceList={fetchResult?.presenceOrAbsenceList}
            postSaveHandler={fetchData}
            readOnly={disableEdit}
          />
        )}
        {/* 債権債務 */}
        {fetchResult?.data?.confirmationType ===
          Constants.CONFIRMATION_LETTER_TYPE.RECEIVABLE_PAYABLE && (
          <ReceivablePayableConfirmation
            targetData={fetchResult?.data}
            accountTitles={accountTitles}
            postSaveHandler={fetchData}
            readOnly={disableEdit}
          />
        )}
      </DefaultPaper>

      {/* メール送信ダイアログ */}
      <FormDialog
        open={mailDialogOpen}
        title="確認依頼メール送付"
        onClose={() => setMailDialogOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <MailForm
          confirmationLetterId={params.id}
          confirmationLetterType={fetchResult?.data?.confirmationType}
          closeHandler={handleCloseMailDialog}
        />
      </FormDialog>
    </>
  );
};

export default ConfirmationLetter;
